/** @enum {string} */
export var DeviceTypeEnum;
(function (DeviceTypeEnum) {
    DeviceTypeEnum["PEN"] = "pen";
    DeviceTypeEnum["ERASER"] = "eraser";
    DeviceTypeEnum["PLAYER"] = "player";
    DeviceTypeEnum["STYLUS"] = "stylus";
    DeviceTypeEnum["FSIR"] = "fsir";
    DeviceTypeEnum["NONE"] = "none";
})(DeviceTypeEnum || (DeviceTypeEnum = {}));
export var PenModelEnum;
(function (PenModelEnum) {
    PenModelEnum["F121"] = "pen";
    PenModelEnum["F120"] = "pen";
    PenModelEnum["F51"] = "pen";
    PenModelEnum["F50"] = "pen";
    PenModelEnum["F30"] = "pen";
    PenModelEnum["E100"] = "eraser";
    PenModelEnum["E101"] = "eraser";
    PenModelEnum["X100"] = "stylus";
})(PenModelEnum || (PenModelEnum = {}));
//# sourceMappingURL=pencomm_enum.js.map